var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItInfrastructureManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 66,
    viewBox: "0 0 53 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IT_Infrastructure_Management",
    "data-name": "IT Infrastructure Management"
  }, /*#__PURE__*/React.createElement("image", {
    id: "_16096534681582799504-128",
    "data-name": "16096534681582799504-128",
    x: 3,
    y: 10,
    width: 47,
    height: 46,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAuCAYAAAC4e0AJAAADnklEQVRoge2YSWgUQRSGv4ljXBI31BgFFwQPCgou4EW8iAtqIOjB5aJeXEEIqOAhbqigoiAejKC5KIK4HdwiCoJgwIMiqAc9iLjEuMYtaBKTSOHf4dl2zxYzPYH5YZjq7qrqr1+/eu9VxwpWHSMibQRWAJOBmBBeADXAIeBJMqyCCLgHA3eAw8AUA+40ClgNPAKWJZso3rWc/8gZ6xYwURc+AWeB+8BwYCEwTVyngQ/AjVyB32bA7wKLgDpzfSewCTig4zPACOBn0GQ9YpPLuh75j4pk5d6y6BRZ3q9aoFRvoA/wDHgQNGE2fd4tzAFqnwQaE/TdC7SpPSusUzbhS037cZK+L4Hvag8J62R9fiqwB2gG2jvHSS+9/l3m3EfTHpNkfAnQV+3PYZ0s/FhgbmasgRrmg78H/JAfu/hemWDsBsN2OxV464NvgTeyYKr6pf5jNW+db9xXoAqoAEYCF4GlQJOv32JFJfSwp1KBt3LucyQNcE8DlRlLQq5XCs4lo3LgIXBcY/oDC4Alpv8qPXRa8H5rpKrGJOvFXR8NPNf/OGBfSN+NivOhCos26biLVZEv3QdpC1CcwlyzgUmJOmQzw8ZUdM0x524CV1WQOZebDiyXEcrkRvOB60ETZhP+mgGvUwF2xdfnhEqE3cBKeUaNsu09/4TZSlLbTBh+qmzrB/f0Wgt1pzl3TWXFX+pKeG/uMQbkGzATeJfC+B1AtdpDgYNhN/DrbYbALhu2qu397zbXK9Ocey3wRe31qjA7FObz7rWNT/PNtCt79texqxwLtQARRFUa8zm1yPoVOl4DbA+Ct+15+nVGjQp3Xui8mmH+OGfgy8PgXeJ4FZBkWpQxw2Jznfp4b6ldbRf+Zph+FzI0RK1KleHayBR5pUxcma5EN6wwvurpu7LdwoCJXQW6VRVjoTkfk/8fMuecO03IIEi4e9QLPiY3dNvGD+7rwWUlAwfdEJIhixNk3QazcfDUpjF90gQNU3sA1xVn+Z466JGo8E+gQf8JMJGCDNozbhaR86N1ihLZ3pinol+K90e1UWmykG1ygU96C7mmVhm1I6BY+H7ApRyEDlUUX8z+m6zlvymzNuToQ7UpoFQr1v8F7xbu+ejYUlaVB28tXKDVnMsqtczd2ufz8FEpDx+V8vBRKQ8flfLwUcnCu2L/fY7z1tv9sq0q3dZqs3ZShcFjI1WzSuKOb5Zx8wCuzNyfg9Bhiju3+efra7cQ9P4NJBqqgoJKvfAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItInfrastructureManagement);
export default __webpack_public_path__ + "static/media/IT Infrastructure Management.40492bd9b45922f0106832de014ee1b8.svg";
export { ForwardRef as ReactComponent };